import * as React from 'react';
import * as styles from '../Icon.css';

export const metro = () => (
  <div className={styles['icon-metro']}></div>
);
